import api from './api';
import { Contrato } from './contrato';

export interface TipoServico {
  id: string;
  nome: string;
  sigla?: string;
  descricao?: string;
  servicoCritico?: boolean;
}

export const getAllTiposServico = () => api.get<TipoServico[]>('tiposServico');
export const getAllTiposServicoFilter = (exigeEspecificacao?: boolean) =>
  api.post<TipoServico[]>(`tiposServico/tipoServicoFilter`, { exigeEspecificacao }, { disableNotification: 'true' });
export const createTipoServico = (TipoServico: TipoServico) => {
  return api.post<TipoServico>('tiposServico', TipoServico);
};
export const updateTipoServico = (TipoServico: TipoServico) => api.put<TipoServico>(`tiposServico`, TipoServico);
export const deleteTipoServico = (id: string) => api.delete(`tiposServico/${id}`);

export const getTipoServicoOptions = () =>
  getAllTiposServico().then(tipoServico =>
    (tipoServico || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getTipoServicoFilterOptions = (exigeEspecificacao?: boolean) =>
  getAllTiposServicoFilter(exigeEspecificacao).then(tipoServico =>
    (tipoServico || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getTipoServicoAcordoFornecimento = () => api.get<TipoServico[]>('tiposServico/AcordoFornecimento');
export const getTipoServicoAcordoFornecimentoOptions = () =>
  getTipoServicoAcordoFornecimento().then(tipoServico =>
    (tipoServico || []).map(item => ({ text: item.nome, value: item.id.toString() })),
  );

export const getTipoServicoContratoAcordoFornecimento = (id: string) =>
  api.get<Contrato>(`tiposServico/GetContratoAcordoFornecimento/${id}`);
